<template name="component-name">
  <v-sheet>
    <v-container fluid>
      <v-row>
        <v-col
          cols="12"
          md="3"
          sm="12"
          lg="3"
          v-for="(card, index) in cards"
          :key="index"
        >
          <v-card class="pa-4" elevation="2" :color="card.color">
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-h6">{{ card.title }}</div>
                <div class="text-h4 font-weight-bold">{{ card.count }}</div>
              </div>
              <v-icon size="40" color="white">
                {{ card.icon }}
              </v-icon>
            </div>
          </v-card>
        </v-col>
        <v-col col="12" md="6" sm="12" lg="6">
          <v-card variant="outlined">
            <v-card-title primary-title> Upcoming Events </v-card-title>
            <v-data-table
              :headers="upcomingEventsHeaders"
              :items="upcomingEvents"
              item-key="id"
              :items-per-page="5"
              :search="search"
            >
            </v-data-table>
          </v-card>
        </v-col>
        <v-col col="12" md="6" sm="12" lg="6">
          <v-card variant="outlined">
            <v-card-title primary-title> Top Event </v-card-title>
            <v-data-table
              :headers="topEventHeaders"
              :items="topEvent"
              item-key="id"
              :items-per-page="5"
              :search="search"
            >
            </v-data-table>
          </v-card>
        </v-col>
        <v-col col="12" md="12" sm="12" lg="12">
          <v-card variant="outlined">
            <v-card-title primary-title> Event Summary </v-card-title>
            <v-data-table
              :headers="eventSummaryHeaders"
              :items="eventSummary"
              :group-by="groupBy"
              item-key="id"
              :items-per-page="10"
              :search="search"
              show-group-by
              :expanded="expanded"
            >
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      drawer: true,
      cards: [
        {
          title: "Total Events",
          count: 42,
          icon: "mdi-calendar-multiselect",
          color: "indigo",
        },
        {
          title: "Total Attendees",
          count: 1280,
          icon: "mdi-account-group",
          color: "teal",
        },
        {
          title: "Total Check-ins",
          count: 1104,
          icon: "mdi-checkbox-marked-circle-outline",
          color: "green",
        },
        {
          title: "Upcoming Events",
          count: 5,
          icon: "mdi-calendar-clock",
          color: "orange",
        },
      ],
      eventSummary: [],
      upcomingEvents: [],
      topEvent: [],
      expanded: [],
      groupBy: [{ key: "name", order: "asc" }],
      eventSummaryHeaders: [
        { title: "Event Name", value: "name" },
        { title: "Gender", value: "gender" },
        { title: "Total Attendees", value: "total_attendees" },
        { title: "Checked In", value: "checked_in" },
      ],
      upcomingEventsHeaders: [
        { title: "Event Name", value: "name" },
        { title: "Date", value: "date" },
      ],
      topEventHeaders: [
        { title: "Event Name", value: "name" },
        { title: "Total Attendees", value: "total_attendees" },
      ],
    };
  },
  methods: {
    getDashboardData() {
      // Fetch data from API or perform any other logic
      // For now, we are using static data
      // You can replace this with an API call
      axios
        .get("/api/dashboard")
        .then((response) => {
          // Assuming the response contains the data in the same format
          console.log("Dashboard data:", response.data);

          this.cards = response.data.cards;
          this.eventSummary = response.data.eventResults;
          this.upcomingEvents = response.data.stats.upcoming_events;
          this.topEvent = response.data.stats.top_events;
        })
        .catch((error) => {
          console.error("Error fetching dashboard data:", error);
        });
    },
  },
  mounted() {
    this.getDashboardData();
  },
  watch: {
    eventSummary: {
      handler(val) {
        // Ensure expanded list is updated whenever eventSummary changes
        this.expanded = [...new Set(val.map((item) => item.name))];
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.v-main {
  padding-left: 0 !important;
}
</style>